import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
// import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
// import Avatar from '@material-ui/core/Avatar';
// import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
// import MoreVertIcon from '@material-ui/icons/MoreVert';
import Grid from "@material-ui/core/Grid";

export default function CardNews(props) {
	const classes = useStyles();

	return (
		<Card className={classes.root} id='cardNews'>
			{props.header !== 'Invalid date' ?
				<CardContent className={classes.content}>
					<Grid container direction="row">
						<Grid container item className={classes.header}>
							<Typography className={classes.title}>
								{props.header}
							</Typography>

							<svg className={classes.action} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle cx="6" cy="6" r="3" stroke="#BCBBD0" strokeWidth="2" />
								<circle cx="18" cy="6" r="3" stroke="#BCBBD0" strokeWidth="2" />
								<circle cx="6" cy="18" r="3" stroke="#BCBBD0" strokeWidth="2" />
								<circle cx="18" cy="18" r="3" stroke="#BCBBD0" strokeWidth="2" />
								<path d="M6 9V15" stroke="#BCBBD0" strokeWidth="2" />
								<path d="M8.9259 18.2963H15.3333" stroke="#BCBBD0" strokeWidth="2" />
								<path d="M8.66675 5.7037L14.5927 5.7037" stroke="#BCBBD0" strokeWidth="2" />
								<path d="M18 8.22221V15.6296" stroke="#BCBBD0" strokeWidth="2" />
							</svg>
						</Grid>

						<Grid item className={classes.body}>
							<Typography variant="body2" color="textSecondary" component="span" numberOfLines={1} ellipsizeMode='head' className={classes.bodyText}>
								{props.langIsRu ? props.text : 'Participate in CFT event'}
							</Typography>
						</Grid>

						<Grid item>
							<a className={classes.LinkType2} href={props.langIsRu ? props.link : 'https://www.cft.ru/events#_tab2'} rel="noopener noreferrer" target="_blank"> {props.langIsRu ? 'Подробнее' : 'More'}</a>
						</Grid>
					</Grid>
				</CardContent>
				:
				''
			}
		</Card>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		// maxWidth: 345,
		boxShadow: '6px 6px 15px rgba(64, 102, 199, 0.02)',
		borderRadius: theme.spacing(2),
		padding: theme.spacing(3),
		minHeight: 197,
		height: 197,
		maxHeight: 197
	},

	avatar: {
		backgroundColor: '#EBEEFF',
		height: 62,
		width: 62,
		borderRadius: 24
	},

	icon: {
		marginLeft: 'auto',
	},

	header: {
		flexGrow: 1,
		marginBottom: 16
	},

	title: {
		fontSize: 16,
		color: '#BCBBD0',
		flexGrow: 1
	},

	action: {
		width: 24,
		height: 24,
		padding: 0
	},

	content: {
		padding: '0 !important',
		overflow: 'hidden'
	},

	body: {
		marginBottom: 17,
		width: '100%',
		height: 72,
		maxHeight: 72,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		display: '-webkit-box',
		'-webkit-line-clamp': '3',
		'-webkit-box-orient': 'vertical',
	},

	bodyText: {
		color: '#3C3C56',
		fontSize: 16,
		lineHeight: '24px',
	},

	LinkType2: {
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: 400,
		color: '#8987A2',
		textDecoration: 'none',

		'&:hover': {
			color: '#24262A',
			textDecoration: 'none',
			borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
		}
	},
}));